import axios from 'axios';
import * as apiConstant from './apiConstant';

/****************************************
    Menu management API
    @author  IMH003
    @date    2020.5.12
    @version 0.1    
 ******************************************/
class menuApi {
    static getMenuList() {
        var lang_key = localStorage.getItem('language');
        return axios({
          url : `${apiConstant.API_URL}/menu/${(lang_key === undefined || lang_key === null) ? 'en' : lang_key}`,
          method: 'GET',
          headers: {
            'accept': 'application/json'
          }                  
        })     
        .then(function (response) {
            return response;              
        })
        .catch(function (error) {
          throw error;
        });    
    }
    
}

export default menuApi;